// source: src/common/integration/object/object.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_integration_object_field_field_pb = require('../../../../src/common/integration/object/field/field_pb.js');
goog.object.extend(proto, src_common_integration_object_field_field_pb);
var src_common_tenant_mapping_v2_object_mapping_pb = require('../../../../src/common/tenant/mapping/v2/object_mapping_pb.js');
goog.object.extend(proto, src_common_tenant_mapping_v2_object_mapping_pb);
var src_common_nullable_nullable_pb = require('../../../../src/common/nullable/nullable_pb.js');
goog.object.extend(proto, src_common_nullable_nullable_pb);
goog.exportSymbol('proto.loupe.common.integration.object.IntegrationObject', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.integration.object.IntegrationObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.integration.object.IntegrationObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.integration.object.IntegrationObject.displayName = 'proto.loupe.common.integration.object.IntegrationObject';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.integration.object.IntegrationObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.integration.object.IntegrationObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.object.IntegrationObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    idKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fieldsMap: (f = msg.getFieldsMap()) ? f.toObject(includeInstance, proto.loupe.common.integration.object.field.IntegrationObjectField.toObject) : [],
    objectMapping: (f = msg.getObjectMapping()) && src_common_tenant_mapping_v2_object_mapping_pb.ObjectMapping.toObject(includeInstance, f),
    modifiedTs: (f = msg.getModifiedTs()) && src_common_nullable_nullable_pb.NullTimestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.integration.object.IntegrationObject}
 */
proto.loupe.common.integration.object.IntegrationObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.integration.object.IntegrationObject;
  return proto.loupe.common.integration.object.IntegrationObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.integration.object.IntegrationObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.integration.object.IntegrationObject}
 */
proto.loupe.common.integration.object.IntegrationObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = msg.getFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.loupe.common.integration.object.field.IntegrationObjectField.deserializeBinaryFromReader, "", new proto.loupe.common.integration.object.field.IntegrationObjectField());
         });
      break;
    case 5:
      var value = new src_common_tenant_mapping_v2_object_mapping_pb.ObjectMapping;
      reader.readMessage(value,src_common_tenant_mapping_v2_object_mapping_pb.ObjectMapping.deserializeBinaryFromReader);
      msg.setObjectMapping(value);
      break;
    case 6:
      var value = new src_common_nullable_nullable_pb.NullTimestamp;
      reader.readMessage(value,src_common_nullable_nullable_pb.NullTimestamp.deserializeBinaryFromReader);
      msg.setModifiedTs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.integration.object.IntegrationObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.integration.object.IntegrationObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.object.IntegrationObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.loupe.common.integration.object.field.IntegrationObjectField.serializeBinaryToWriter);
  }
  f = message.getObjectMapping();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      src_common_tenant_mapping_v2_object_mapping_pb.ObjectMapping.serializeBinaryToWriter
    );
  }
  f = message.getModifiedTs();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      src_common_nullable_nullable_pb.NullTimestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string object_key = 1;
 * @return {string}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.getObjectKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.setObjectKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id_key = 2;
 * @return {string}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.getIdKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.setIdKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, field.IntegrationObjectField> fields = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.loupe.common.integration.object.field.IntegrationObjectField>}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.getFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.loupe.common.integration.object.field.IntegrationObjectField>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.loupe.common.integration.object.field.IntegrationObjectField));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.clearFieldsMap = function() {
  this.getFieldsMap().clear();
  return this;};


/**
 * optional loupe.common.tenant.mapping.v2.ObjectMapping object_mapping = 5;
 * @return {?proto.loupe.common.tenant.mapping.v2.ObjectMapping}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.getObjectMapping = function() {
  return /** @type{?proto.loupe.common.tenant.mapping.v2.ObjectMapping} */ (
    jspb.Message.getWrapperField(this, src_common_tenant_mapping_v2_object_mapping_pb.ObjectMapping, 5));
};


/**
 * @param {?proto.loupe.common.tenant.mapping.v2.ObjectMapping|undefined} value
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
*/
proto.loupe.common.integration.object.IntegrationObject.prototype.setObjectMapping = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.clearObjectMapping = function() {
  return this.setObjectMapping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.hasObjectMapping = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional loupe.common.nullable.NullTimestamp modified_ts = 6;
 * @return {?proto.loupe.common.nullable.NullTimestamp}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.getModifiedTs = function() {
  return /** @type{?proto.loupe.common.nullable.NullTimestamp} */ (
    jspb.Message.getWrapperField(this, src_common_nullable_nullable_pb.NullTimestamp, 6));
};


/**
 * @param {?proto.loupe.common.nullable.NullTimestamp|undefined} value
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
*/
proto.loupe.common.integration.object.IntegrationObject.prototype.setModifiedTs = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.integration.object.IntegrationObject} returns this
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.clearModifiedTs = function() {
  return this.setModifiedTs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.integration.object.IntegrationObject.prototype.hasModifiedTs = function() {
  return jspb.Message.getField(this, 6) != null;
};


goog.object.extend(exports, proto.loupe.common.integration.object);
